import React, {useContext} from 'react';
import { UserContext } from '../../App';

const User = () => {
    let {user} = useContext(UserContext)
    return (
        <>
            {user.accessToken ?
                <div className="card w-96 glass mx-auto mt-10">
                    {
                        user.photoURL && <figure><img src={user.photoURL} alt=""/></figure>
                    }
                    <div className="card-body">
                        <h2 className="card-title mx-auto">{user.displayName}</h2>
                    {
                        user.email && 
                        <p>{user.email}</p>
                    }
                    </div>
                </div> :
                <h1 className='text-4xl text-warning mt-20'>Please Log In first</h1>
            }
        </>
    );
};

export default User;